<template>
  <div class="p-8" style="width: 100%;" >
    <div class="availability-columns-wrapper">
      <div class="availability-left-column">
        <p v-if="showAttentionMessage" class="attention-text">
      Atenção: deve votar a verde ou amarelo em, <br />pelo menos, {{ this.eventMinDuration }} {{ eventDuration === 'hours' ? ' horas seguidas' : ' dias seguidos'}}.
    </p>

        <!-- Renderizar um calendário por mês -->
        <div class="calendar-container">
          <mc-progress-bar
            :active="savingTimes"
            :label="'Guardando atualizações de horário...'"
            color="bg_secondary"
            class="flex-shrink-0"
            :errorLabel="failedFetching ? 'Erro a guardar horários! Tente novamente.' : ''"
          />
          <div v-for="(dates, month) in groupedDatesSorted" :key="month" class="calendar-wrapper">
            <!-- <div class="v-picker__body v-picker__body--no-title"> -->
            <div class="">
              <CustomCalendar
                :key="eventDatesKey"
                :available-dates="allowedDates(month)"
                :selectedColors="localSelectedColors"
                :eventTimes="eventTimes"
                v-model="selectedDate"
                context="event-dates"
                @update:modelValue="onDateSelected"
                @save-times="saveTimes"
                :currentMonth="getMonthFromData(month)"
                :currentYear="getYearFromData(month)"
                :selectedOption="selectedOption"
              />
            </div>
          </div>
        </div>
  
      </div>
      <div class="availability-right-column">
        <div v-if="!isMobile && toggleHours && selectedDate" class="scrollable-container scrollable-container-times">
                <h3
                  v-if="selectedDate && selected === 'calendar'"
                  :class="[
                      context === 'event-availability'? ['feathered-edges', 'bottom'] : ''
                    ]"
                >{{ formatDateExtense(selectedDate) }}</h3>
                <EventTimes
                  :key="reloadedEvents"
                  v-if="selectedDate && selected === 'calendar'"
                  :eventTimes="getEventTimes"
                  :selectedDate="selectedDate"
                  :selectedOption.sync="selectedOption"
                  :autoSelectAll="!toggleHours"
                  :minDurationValue="eventDurationValue"
                  @time-selected="onTimeSelected"
                  ref="eventTimes"
                  @reload-calendar="refreshFromServer"
                  :context="'event-dates'"
                />
        </div>

        <v-dialog v-model="eventTimesDialog" v-if="isMobile && toggleHours && selectedDate">
          <v-card class="event-times-card">

            <!-- HEADER FIXO -->
            <v-card-title class="event-times-header background-image">
              <h5 class="header-text">{{ formatDateExtense(selectedDate) }}</h5>
              <v-spacer></v-spacer>
              <v-btn icon color="red" @click="$emit('update:eventTimesDialog', false)" class="btn-left header-button">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              
              <div class="buttons-row">
                <v-btn
                  v-for="(option, index) in options"
                  :key="index"
                  @click="onOptionSelected(option.value)"
                  :class="[option.class, {'active-button': selectedOption === option.value}]"
                  fab x-small outlined dense
                  class="status-button"
                />
              </div>
            </v-card-title>

            <!-- BOTÕES (rolam com o resto do conteúdo) -->
            <!-- <v-card-title class="headline background-image">
              <div class="buttons-row">
                <v-btn
                  v-for="(option, index) in options"
                  :key="index"
                  @click="onOptionSelected(option.value)"
                  :class="[option.class, {'active-button': selectedOption === option.value}]"
                  fab x-small outlined dense
                  class="status-button"
                />
              </div>
            </v-card-title> -->

            <!-- CORPO COM SCROLL -->
            <v-card-text class="ma-0 pa-0 dialog-body">
              <EventTimes
                :key="reloadedEvents"
                v-if="selectedDate && selected === 'calendar' && toggleHours"
                :eventTimes="getEventTimes"
                :selectedDate="selectedDate"
                :selectedOption.sync="selectedOption"
                :autoSelectAll="!toggleHours"
                @time-selected="onTimeSelected"
                @option-selected="onOptionSelected"
                ref="eventTimes"
                @reload-calendar="refreshFromServer"
              />
            </v-card-text>

            <!-- <v-card-actions class="headline">
              <v-spacer></v-spacer>
            </v-card-actions> -->

          </v-card>
        </v-dialog>
      </div>

    </div>
  </div>
</template>

<script>
import Events from '@/api/Events.js';
import CustomCalendar from '@/components/ui/CustomCalendar.vue'
import EventTimes from './EventTimes.vue';
import dayjs from 'dayjs'
import 'dayjs/locale/pt'
// import EventAvailabilityControls from './EventAvailabilityControls.vue';

// ---------- Helpers de tempo ----------
const toMinutes = (hhmm) => {
  const [H, M] = (hhmm || '00:00').split(':').map(Number);
  return H * 60 + (isNaN(M) ? 0 : M);
};
const minutesToHHMM = (m) => {
  const H = String(Math.floor(m / 60)).padStart(2, '0');
  const M = String(m % 60).padStart(2, '0');
  return `${H}:${M}`;
};

// Normaliza por dia: remove duplicados, ordena, e em "por dia" colapsa para 1 slot
const normalizeDaySlots = (timesByDate, isHours) => {
  const out = {};
  Object.entries(timesByDate || {}).forEach(([date, list]) => {
    const byTime = new Map();
    (list || []).forEach(s => {
      const time = (s.time || '00:00').slice(0, 5);
      byTime.set(time, { time, value: s.value ?? null });
    });
    let unique = Array.from(byTime.values()).sort((a,b) => toMinutes(a.time) - toMinutes(b.time));
    if (!isHours) {
      const lastDefined = unique.map(x => x.value).filter(v => v != null).pop() ?? null;
      unique = [{ time: '00:00', value: lastDefined }];
    }
    out[date] = unique;
  });
  return out;
};

const hasMinimumConsecutiveHourVotes = (timesByDate, minDurationHours) => {
  const requiredSlots = Math.max(1, Number(minDurationHours || 0) * 2);


  return Object.values(timesByDate || {})
    // search timesByDate until one day has sufficient votes to match minDurationHours
    .some((slots) => {
      // Order slots by time incase they somehow get there unordered
      const orderedSlots = (slots || [])
        .map(slot => ({ ...slot, time: (slot.time || "00:00").slice(0, 5) }))
        .sort((a, b) => toMinutes(a.time) - toMinutes(b.time));

      let consecutiveSlots = 0;
      let previousMinutes = null;

      for (const slot of orderedSlots) {
        const isValidVote = slot.value === 2 || slot.value === 3;
        const currentMinutes = toMinutes(slot.time);

        // resart the counter as soon as a non-valid vote is found
        if (!isValidVote) {
          consecutiveSlots = 0;
          previousMinutes = null;
          continue;
        }

        // start the counter if currentMinutes is not 30 minutes after the previous slot
        if (previousMinutes !== null && currentMinutes - previousMinutes !== 30) {
          consecutiveSlots = 0;
        }

        consecutiveSlots += 1;
        previousMinutes = currentMinutes;
        // as soon as enought consecutive slots are found break early
        if (consecutiveSlots >= requiredSlots) {
          return true;
        }
      }

      return false;
  });
};

export default {
  components:{ 
    CustomCalendar,
    EventTimes,
    // EventAvailabilityControls,
  },

  props: {
    eventId: { type: String, required: true },
    eventDates: { type: Array, required: true },
    eventDuration: { type: String, default: "" },     // 'hours' | 'days' | 'weeks'
    toggleHours: Boolean,
    selectedColors: { type: Object, default: () => ({}) },
    eventTimes: { type: Object, default: () => ({}) },
    showAttention: { type: Boolean, default: false },
    selected: { type: String, default: 'calendar' },
    updateToggleHours: { type: Function, default: () => {} },
    loadEvent: { type: Function, default: () => {} },
    selectedOption: {type: Number, default: 0},
    // fetching: {type: Boolean, default: false,},
    // failedFetching: {type: Boolean, default: false},
    eventDurationValue: {type: Number, default: 0,},
    onTimeSelected: {type: Function, default: () => {},},
    context: {type: String, default: "",},
    isMobile: {type: Boolean, default: false,},
    eventTimesDialog: {type: Boolean, default: false,},
    savingTimes: {type: Boolean, default: false,},
  },

  data() {
    return {
      eventDatesKey: 0,
      localToggleHours: this.toggleHours,
      options: [
        { value: 1, class: 'red-button' },
        { value: 2, class: 'yellow-button' },
        { value: 3, class: 'green-button' },
        { value: 0, class: "x-button"}
      ],
      activeOption: 3,
      selectedDate: null,
      eventMinDuration: 0,
      localEventDates: [...this.eventDates],
      localSelectedColors: { ...this.selectedColors },
      localEventTimes: { ...this.eventTimes },
      groupedDates: {},
      // isMobile: false,
      fetching: false,
      failedFetching: false,
      reloadedEvents: 0,
      // selectedOption: 0,
      // loadEvent: () => {},
    };
  },

  methods: {
    reloadEventDates(){ this.eventDatesKey++ },
    async refreshFromServer() {
      await this.loadEvent(false);
      await this.$nextTick();

      this.localEventDates = [...this.eventDates];
      this.localEventTimes = normalizeDaySlots(this.eventTimes || {}, this.eventDuration === "hours");

      this.reloadedEvents++;
      this.reloadEventDates();
    },

    async saveTimes() {
      this.$emit("update:savingTimes", true);
      this.fetching = true;
      this.failedFetching = false;

      try {
        if (!this.selectedDate) {
          console.warn("⚠ Nenhuma data selecionada para salvar.");
          return;
        }

        const toggleHours = this.toggleHours;
        const isHours = this.eventDuration === "hours";
        let votes = [];

        if (isHours && toggleHours) {
          const events = (this.localEventTimes[this.selectedDate] || [])
            .slice()
            .sort((a, b) => toMinutes(a.time) - toMinutes(b.time));

          votes = events.map((event) => {
            const vote_start = `${this.selectedDate}T${event.time}:00`;
            const mStart = toMinutes(event.time);
            const mEnd = mStart + 30;
            const endHHMM = minutesToHHMM(Math.min(mEnd, 23 * 60 + 59));
            const vote_end = `${this.selectedDate}T${endHHMM}:00`;

            return {
              vote_start,
              vote_end,
              vote_value: this.selectedOption
            };
          });
        } else {
          votes.push({
            vote_start: `${this.selectedDate}T00:00:00`,
            vote_end: `${this.selectedDate}T23:59:00`,
            vote_value: this.selectedOption
          });
        }

        const params = {
          user_id: this.$root.session.id,
          event_id: this.eventId,
          date: this.selectedDate,
          votes,
          valid_vote: !this.showAttentionMessage
        };

        await Events.insertTime(params);
        await this.refreshFromServer();
      } catch (error) {
        console.error("Erro ao salvar horários:", error);
        this.failedFetching = true;
      } finally {
        this.$emit("update:savingTimes", false);
        this.fetching = false;
      }
    },
    formatDateExtense(date) {
      const parsed = dayjs(date)
      return parsed.isValid() ? parsed.locale('pt').format('D [de] MMMM') : ''
    },
    getMonthFromData(data){ return parseInt(data.split('-')[1]) - 1 },
    getYearFromData(data){ return parseInt(data.split('-')[0]) },

    groupDatesByMonth(dates) {
      if (!Array.isArray(dates)) {
        console.warn('⚠ eventDates não é um array:', dates);
        this.groupedDates = {};
        return;
      }
      this.groupedDates = dates.reduce((acc, date) => {
        const month = date.slice(0, 7);
        if (!acc[month]) acc[month] = [];
        acc[month].push(date);
        return acc;
      }, {});
    },

    allowedDates(month) {
      return this.groupedDates[month] || [];
    },


    onOptionSelected(option) {
      // this.selectedOption = option;
      this.activeOption = option;
      this.$emit('option-selected', option);
    },

    onDateSelected(date) {
      if (!this.toggleHours) {
        // por dia
        this.$emit('date-selected', { date, option: this.selectedOption, autoSelectAll: true });

        this.localSelectedColors = { ...this.localSelectedColors, [date]: this.selectedOption };

        if (this.localEventTimes[date]) {
          this.localEventTimes = {
            ...this.localEventTimes,
            [date]: this.localEventTimes[date].map((event) => ({ ...event, value: this.selectedOption }))
          };
        }
      } else {
        // por horas
        this.$emit('date-selected', { date, option: this.selectedOption, autoSelectAll: false });
      }
      this.$emit('date-changed', date);
    }
  },

  watch: {
    toggleHours(newVal) {
      this.localToggleHours = newVal;
    },
    eventDates: {
      immediate: true,
      handler(newDates) {
        this.localEventDates = [...newDates];
        this.groupDatesByMonth(newDates);
      }
    },
    selectedColors: {
      immediate: true,
      deep: true,
      handler(newColors) {
        this.localSelectedColors = { ...newColors };
      }
    },
    eventTimes: {
      immediate: true,
      deep: true,
      handler(time) {
        const isHours = (this.eventDuration) === 'hours';
        // normaliza o que vem de fora para não reintroduzir duplicados
        const normalized = normalizeDaySlots(time || {}, isHours);
        this.localEventTimes = normalized;
      }
    },
    eventDuration: {
      immediate: true,
      handler() {
        const normalized = normalizeDaySlots(this.eventTimes || {}, this.eventDuration === 'hours');
        this.localEventTimes = normalized;
      }
    },

    eventDurationValue: {
      immediate: true,
      deep: true,
      handler(eventDurationValue) {
        this.eventMinDuration = eventDurationValue;
      }
    }
  },

  created() {
    if (this.localEventDates.length === 0) {
      this.loadEvent();
    }
  },
  mounted() {
    
  },
  computed: {
    getEventTimes(){
        //eventTimes[selectedDate] || []
        // this.loadEvent();
        this.reloadEventDates();
        console.log('Obtendo horários de eventos para a data:', this.eventTimes);
        return this.getLocalEventTimes[this.selectedDate] || []
      },
    showAttentionMessage() {
      if (this.eventDuration === 'hours') {
        return !hasMinimumConsecutiveHourVotes(this.getLocalEventTimes, this.eventMinDuration);
      }

      const votedDays = Object
                          .values(this.getLocalEventTimes)
                          .filter((times) => {
                            const value = (Array.isArray(times) 
                                            && times.length > 0
                                            && times[0].value !== undefined
                                          )
                                          ? times[0].value : null
                                          ;
                            return value === 2 || value === 3;
                          }).length;
      
      return votedDays < this.eventMinDuration;
    },
    processedEventDates() {
      return this.localEventDates ? [...this.localEventDates] : [];
    },
    getLocalEventTimes() {
      // belt-and-braces: devolve sempre normalizado
      const isHours = (this.eventDuration) === 'hours';
      return normalizeDaySlots(this.localEventTimes || {}, isHours);
    },
    groupedDatesSorted() {
      const sortedEntries = Object.entries(this.groupedDates)
        .sort((a, b) => new Date(a[0] + '-01') - new Date(b[0] + '-01'));
      return Object.fromEntries(sortedEntries);
    },
  },
};
</script>

<style scoped>

.event-fetch-status
{
  align-self: flex-start;
}
.availability-columns-wrapper 
{
  display: flex;
  flex-direction: column;
  gap: 1em;
  height: 100%;
  /* TODO: FIXME: find a better way to set this size */
  --min-h-availability-containers: 450px;
  min-height: var(--min-h-availability-containers);
  max-height: calc(100vh - var(--min-h-availability-containers));
  @media (min-width: 560px) {
    align-items: center;
  }
  @media (min-width: 960px)
  {
    flex-direction: row;
    align-items: flex-start;
  }
}

.availability-columns-wrapper .availability-left-column,
.availability-columns-wrapper .availability-right-column
{
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  /* TODO: FIXME: find a better way to set this measurement */
  /* Currently set / inherited from EventView.vue */
  max-width: var(--max-sub-col-width);
}
.availability-columns-wrapper .availability-left-column
{
  /* TODO: FIXME: find a better way to set this measurement */
  min-height: 450px;
  width: 100%;
}

.calendar-container,
.scrollable-container-times
{
  overflow-y: auto;
  height: 100%;

  & ::v-deep h3 
  {
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.5rem 0;
    margin-bottom: 0.5rem; 
    
  }
}
.scrollable-container-times
{
  visibility: visible;
  opacity: 1;
  width: auto;
  transition: all 1s ease-in-out;
}

.scrollable-container-times h3
{
  background-color: var(--app-color-bg-primary);
  position: sticky;
  top: 0;
  z-index: 1;
}

@starting-style
{
  .scrollable-container-times
  {
    width: 0;
    opacity: 0;
    visibility: hidden;
    height: 0;
    overflow: hidden;
  }
}

.calendar-container ::v-deep .calendar-wrapper
{
  overflow: visible;

  & .calendar {
    overflow: visible;
  }
}



.attention-text { 
  color: red; 
  margin-top: 20px; 
  text-align: center; 
  font-size: 1rem; 
}
</style>
